import { lazy } from 'react';
export const UsersPageAsync = lazy(() => import('./UsersPage'));
